export default "__VITE_ASSET__Dg4$M0ZK__"